import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrow-left-icon',
  templateUrl: './navigation-arrow-left.component.html'
})
export class NavigationArrowLeftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
